export default __webpack_public_path__ + "static/media/EM0360.34I-23431_-15367_0.094e7018.jpg";